import { render, staticRenderFns } from "./ScientificConsultationRequestView.vue?vue&type=template&id=ce28b6b4&scoped=true"
import script from "./ScientificConsultationRequestView.vue?vue&type=script&lang=js"
export * from "./ScientificConsultationRequestView.vue?vue&type=script&lang=js"
import style0 from "./ScientificConsultationRequestView.vue?vue&type=style&index=0&id=ce28b6b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce28b6b4",
  null
  
)

export default component.exports